type ParseOptions = {
    onError?: (error: unknown) => void;
};

const JSONHelpers = {
    parse: <T = unknown>(value: string | null | undefined, options: ParseOptions = {}): T | null => {
        if (!value) {
            return null;
        }

        try {
            return JSON.parse(value) as T;
        } catch (error) {
            options.onError?.(error);
            return null;
        }
    },
};

export { JSONHelpers };
